import React from "react";
import type { ListItemProps as UIListItemProps, ListItemTextProps } from "@material-ui/core";
import { ListItem as UIListItem, ListItemText } from "@material-ui/core";
import type { ListItemIconProps } from "./ListItemIcon";
import { ListItemIcon } from "./ListItemIcon";

type ListItemWithIconProps = UIListItemProps & ListItemIconProps & Pick<ListItemTextProps, "primary" | "secondary">;

export const ListItemWithIcon = React.forwardRef((props: ListItemWithIconProps, ref: React.Ref<HTMLLIElement>) => {
    const { icon, button, children, primary, secondary, ...listItemProps } = props;
    return (
        <UIListItem {...listItemProps} button={button as any} ref={ref}>
            <ListItemIcon icon={icon} />
            <ListItemText primary={primary} secondary={secondary}>
                {children}
            </ListItemText>
        </UIListItem>
    );
});
